import { APIService } from 'connectors/api/rest';

export const Branches = {
  async getList(params) {
    try {
      return await APIService.GET('branches', params);
    } catch (e) {
      return null;
    }
  },
};
